import { useSelector, useDispatch } from "react-redux";
import { kbaseSelectors } from "../../../knowledge/store/kbaseReducer";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { loadKBases } from "../../../knowledge/store/kbaseActionCreators";
import { useEffect, useState } from "react";
import { BookIcon } from "lucide-react";
import { Switch } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

import "./KnowledgeBaseSelector.scss";

const KnowledgeBaseSelector = ({ selectedKBases, onKBasesChange, isReadOnly = false }) => {
  const { workspaceId } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const kbaseList = useSelector(kbaseSelectors.getList);
  const [showSelectorPanel, setShowSelectorPanel] = useState(false);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadKBases(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId]);

  if (!kbaseList || kbaseList.length === 0) {
    return null;
  }

  return (
    <div className="kbase_selector_component">
      <div
        className={
          "prompt_textarea_toolbar_action" +
          (selectedKBases.length > 0 ? " selected" : "") +
          (isReadOnly ? " readonly" : "")
        }
        onClick={() => setShowSelectorPanel(true)}
        title={isReadOnly ? "Knowledge bases are predefined by assistant" : ""}
      >
        <BookIcon
          color={selectedKBases.length > 0 ? "#8358ff" : "#344767"}
          size={20}
        />
      </div>
      {showSelectorPanel && (
        <div className="selector_panel_container">
          <div
            className="cover"
            onClick={() => setShowSelectorPanel(false)}
          ></div>
          <div className="selector_panel">
            {kbaseList.map((kbase) => (
              <div className="kbase_selector_item" key={kbase.uid}>
                <BookIcon size={20} />
                <div
                  className="kbase_name"
                  onClick={() => {
                    if (isReadOnly) return;
                    if (!selectedKBases.includes(kbase.uid)) {
                      onKBasesChange([...selectedKBases, kbase.uid]);
                    } else {
                      onKBasesChange(
                        selectedKBases.filter((id) => id !== kbase.uid)
                      );
                    }
                  }}
                >
                  {kbase.name}
                </div>
                <div className="kbase_toggle">
                  <Switch
                    checked={selectedKBases.includes(kbase.uid)}
                    color="teal"
                    disabled={isReadOnly}
                    onChange={(event) => {
                      if (isReadOnly) return;
                      event.stopPropagation();
                      const isChecked = event.currentTarget.checked;
                      if (isChecked) {
                        if (!selectedKBases.includes(kbase.uid)) {
                          onKBasesChange([...selectedKBases, kbase.uid]);
                        }
                      } else {
                        onKBasesChange(
                          selectedKBases.filter((id) => id !== kbase.uid)
                        );
                      }
                    }}
                    thumbIcon={
                      selectedKBases.includes(kbase.uid) ? (
                        <IconCheck
                          size={12}
                          color="var(--mantine-color-teal-6)"
                          stroke={3}
                        />
                      ) : (
                        <IconX
                          size={12}
                          color="var(--mantine-color-red-6)"
                          stroke={3}
                        />
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default KnowledgeBaseSelector;
